<template>
  <div>

    <!-- <div style="position: fixed; top: 400px; left: 10px; background-color: white; border: 1px solid green; padding: 0 5px; box-shadow: 0px 0px 67px 0px rgba(0,0,0,0.75);">
      <div style="font-size: 0.6rem">Active filter</div>
      <div>{{ $store.state[this.dataType].all.filter }}</div>
      <div style="font-size: 0.6rem">Default filter</div>
      <div>{{ this.defaultFilter }}</div>
      <div style="font-size: 0.6rem">Is them be equal?</div>
      <div>{{ this.filterChanged }}</div>
    </div> -->

    <div class="action-list">

      <!-- TABLE CONTROLS -->
      <template v-for="control in tableMeta.controls">
        <div class="select button-group-wrapper" :key="control.action" v-if="control.controlType === 'select'">
          <select v-model="control.value" @change="tableControlAction(control)">
            <option :value="null">{{ control.placeholder }}</option>
            <option v-for="option in control.options" :key="option.key" :value="option.key">{{ option.value }}</option>
          </select>
        </div>
        <div class="select button-group-wrapper" :key="control.action" v-if="control.controlType === 'multi-select'">
          <multi-select style="min-width: 25rem"
            :options="control.options"
            :selected-options="$store.state[dataType].all.filter[control.fieldId]"
            :placeholder="control.placeholder"
            @select="onMultiSelect($event, control)">
          </multi-select>
        </div>
      </template>

      <!-- TABLE ACTIONS -->
      <template v-if="tableMeta.actions">
        <div class="button-group-wrapper table-actions">
          <div class="buttons has-addons">
            <button class="button" v-for="action in tableMeta.actions" :key="action.action" @click="tableAction(action)">
              <span class="icon is-small" v-if="action.iconClass">
                <i :class="action.iconClass"></i>
              </span>
              <span v-if="action.label">{{ action.label }}</span>
            </button>
          </div>
        </div>
      </template>

      <!-- FILTER -->
      <template v-if="filterMeta">
        <div class="button-group-wrapper">

          <!-- DESKTOP -->
          <div class="buttons has-addons is-hidden-touch">
            <button class="button" :class="{ 'is-primary': filterChanged }" @click="resetFilter()" v-if="filterMeta.length > 0">
              <span class="icon">
                <i class="fal fa-undo"></i>
              </span>
              <span>Återställ</span>
            </button>
            <button class="button" @click="openFilterModal()">
              <span class="icon">
                <i class="fal fa-filter"></i>
              </span>
              <span>Filter</span>
            </button>
          </div>

          <!-- MOBILE -->
          <div class="is-flex has-addons is-hidden-desktop">
            <button class="button margin-left" @click="resetFilter()" v-if="filterMeta.length > 0">
              <i class="fal fa-undo"></i>
            </button>
            <button class="button margin-left" @click="openFilterModal()">
              <i class="fal fa-filter"></i>
            </button>
          </div>

        </div>
      </template>

    </div>

  </div>
</template>

<script>

import FilterModal from '@/components/modals/FilterModal'
import { MultiSelect } from '@/components/actions/MultiSelect'

export default {
  components: {
    MultiSelect
  },

  props: {
    dataType: {
      type: String,
      required: true
    },
    tableMeta: {
      type: Object,
      required: true
    },
    filterMeta: {
      type: Array,
      required: false
    }
  },

  data () {
    return {
      filterChanged: false
    }
  },

  methods: {
    onMultiSelect (item, control) {
      this.$store.state[this.dataType].all.filter[control.fieldId] = item

      // // Check if control has method onMultiSelect
      // if (control.onMultiSelect !== undefined && typeof control.onMultiSelect === 'function') {
      //   control.onMultiSelect(item, control.fieldId)
      // }
    },

    openFilterModal () {
      this.$panel(FilterModal, { filterMeta: this.filterMeta, dataType: this.dataType })
    },

    resetFilter () {
      this.$store.dispatch(this.dataType + '/resetFilter')
    },

    tableAction (item) {
      this.$emit('tableAction', item.action)
    },

    tableControlAction (control) {
      this.$emit('tableControlAction', control)
    },

    setFilterChanged () {
      this.filterChanged = this.$store.getters[this.dataType + '/isFilterChanged'](this.$route)
    }
  },

  mounted () {
    this.setFilterChanged()

    this.$watch(() => this.$store.state[this.dataType].all.filter, (newValue) => {
      this.setFilterChanged()
    }, { deep: true })
  }
}
</script>

<style lang="scss" scoped>
  @import "~bulma/sass/utilities/mixins";

  .has-addons {
    flex-wrap: nowrap;
  }

  .margin-left {
    margin-left: 5px;
  }

  .action-list {
    display: flex;
    margin: 0 5px;
    flex-wrap: wrap;

    @include desktop {
      display: flex;
      margin: 0;
      flex-wrap: nowrap;
    }

    .button-group-wrapper {
      margin-left: auto;
      margin-right: 0;

      &.select {
        margin-bottom: 5px;
        @include desktop {
          margin-bottom: 0;
        }
      }

      &.table-actions {
        margin-left: 0;
        @include desktop {
          margin-left: 5px;
        }
      }

      @include desktop {
        margin-left: 5px;
        margin-right: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/table/AgileTableActions.vue